import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import Header from "./Header";
import { Link,  NavLink } from "react-router-dom";
import AccountNav from "./AccountNav";
import { records as writerJobs } from "../../../services/writerJob";
import { payPlan as writerPlan } from "../../../services/writerPlan";
import Posts from "../../blog/Posts";
import { profileStatistic, profileChecklist, getAuthUserData } from "../../../services/user";
import CollapseMenu from ".././CollapseMenu";

class Account extends Component {
    state = {
        jobs: [],
        plan: {},
        welcome: false,
        collapseMenu: false,
        profileStatistic: {},
        profileChecklist: {},
        meta: this.context.state.user
    };

    componentDidMount() {
        //console.log(window.location.origin);
        writerJobs(1)
            .then(response => {
                this.setState({
                    jobs: response.data
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        let temp = JSON.parse(localStorage.getItem("welcome"));
        if (temp) {
            this.setState({ welcome: temp });
        }

        writerPlan()
            .then(response => {
                this.setState({
                    plan: response.data
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        profileStatistic()
            .then(response => {
                this.context.state.updateUser(response.meta);
                this.setState({
                    profileStatistic: response.data,
                    meta: response.meta
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        profileChecklist()
            .then(response => {               
                this.setState({
                    profileChecklist: response.data,                    
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }

    hideWelcome = () => {
        this.setState({ welcome: false });
        localStorage.setItem("welcome", JSON.stringify({ welcome: false }));
    };

    render() {
        const user = this.state.meta;
        //console.log(user);
        return (
            <Fragment>
                <Header></Header>
                <div>
				    {/* <section className="dashboard-nav">
		                <div className="container">
		            	    <div className="head">
		            		    <h1 className="text-white">Welcome back,  { user.first_name }!</h1>
		            			<h2>Let's get to work.</h2>
		            		</div>
							<AccountNav></AccountNav>
		            	</div>
		            </section> */}
                    <section className="jobsDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 mt-4">
                        <div className="container writer-container">  
                            <div className="row">
                                <div className="col-12 col-xl-4 col-md-4">
                                    <div className="card text-center">
                                        <div className="align-items-center">
                                            <div className="col cover-photo">
                                                <img
                                                    src={user.background}
                                                    alt="cover-photo"
                                                />
                                            </div>
                                            <div className="col pt-4 mt-4">
                                                <div
                                                    className={
                                                        user.verification ===
                                                        "Verified"
                                                            ? "avatar avatar-xl user verified"
                                                            : "avatar avatar-xl user"
                                                    }
                                                >
                                                    <a
                                                        href={user.fullurl}
                                                        target="_blank"
                                                    >
                                                        <img
                                                            src={user.image}
                                                            alt={`${user.first_name} ${user.last_name}`}
                                                            className="avatar-img rounded-circle"
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col mt-2">
                                                <h4 className="avtar-name mb-2">
                                                    <a
                                                        href={user.fullurl}
                                                        target="_blank"
                                                    >{`${user.first_name} ${user.last_name}`}</a>
                                                </h4>
                                                <p className="avtar-status">
                                                    {user.membership} |{" "}
                                                    {user.verification}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-auto"></div>

                                        <div className="card-body">
                                            <hr className="mb-3 mt-2" />

                                            <div className="d-flex justify-content-between">
                                                <p className="card-text mb-0">
                                                    Applied Jobs
                                                </p>
                                                <p className="text-muted mb-0">
                                                    <Link
                                                        to={`/account/jobs/applications`}
                                                    >
                                                        {
                                                            this.state
                                                                .profileStatistic
                                                                .applied_jobs_count
                                                        }
                                                    </Link>
                                                </p>
                                            </div>
                                            <hr className="mb-3 mt-3" />

                                            <div className="d-flex justify-content-between">
                                                <p className="card-text mb-0">
                                                    Open Jobs
                                                </p>
                                                <p className="text-muted mb-0">
                                                    <Link to={`/account/jobs`}>
                                                        {
                                                            this.state
                                                                .profileStatistic
                                                                .open_Jobs
                                                        }
                                                    </Link>
                                                </p>
                                            </div>
                                            <hr className="mb-3 mt-3" />

                                            <div className="d-flex justify-content-between">
                                                <p className="card-text mb-0">
                                                    Portfolio Visitors
                                                </p>
                                                <p className="text-muted mb-0">
                                                    <Link
                                                        to={`/account/portfolio/visitors`}
                                                    >
                                                        {
                                                            this.state
                                                                .profileStatistic
                                                                .portfolio_visitors
                                                        }
                                                    </Link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-md-block d-none">
                                        <Posts></Posts>
                                    </div>
                                </div>

                                <div className="col-12 col-xl-8 col-md-8">
                                    {this.state.profileChecklist.display ==
                                    "1" ? (
                                        <div className="get-started mb-5">
                                            <h3 className="mb-3">
                                                Get Started With ProWriter
                                            </h3>
                                            <ul className="checklist">
                                                <li
                                                    className={
                                                        this.state
                                                            .profileChecklist
                                                            .complete_lesson
                                                    }
                                                >
                                                    <a
                                                        href={
                                                            this.state
                                                                .profileChecklist
                                                                .lesson
                                                        }
                                                        target="_blank"
                                                    >
                                                        Complete free course:
                                                        How to Become a
                                                        Freelance Writer
                                                    </a>
                                                </li>
                                                <li
                                                    className={
                                                        this.state
                                                            .profileChecklist
                                                            .complete_portfolio
                                                    }
                                                >
                                                    <a
                                                        href={`/pw/${this.context.state.user.url}`}
                                                        target="_blank"
                                                    >
                                                        Complete your portfolio
                                                    </a>
                                                </li>
                                                <li
                                                    className={
                                                        this.state
                                                            .profileChecklist
                                                            .complete_quiz
                                                    }
                                                >
                                                    <a
                                                        href="/writer/quiz"
                                                        target="_blank"
                                                    >
                                                        Pass English competency
                                                        verification quiz
                                                    </a>
                                                </li>
                                                <li
                                                    className={
                                                        this.state
                                                            .profileChecklist
                                                            .complete_badge
                                                    }
                                                >
                                                    <a href="/account/achievements">
                                                        Earn your first
                                                        Achievement
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    {user.plan_id == "1" ? (
                                        <div className="unlock-plus mb-5">
                                            <div className="row align-items-center">
                                                <div className="col-lg-2 mb-3 mb-lg-0">
                                                    <img
                                                        className="d-block m-auto m-lg-0 pr-0 pr-lg-4"
                                                        src="images/plus.png"
                                                        alt="prowriter-plus"
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-md-12 col-sm-6 col-12 mb-lg-0 mb-md-3 mb-sm-0 mb-3 text-lg-left text-md-center text-sm-left text-center">
                                                    <p>
                                                        Launch and grow your
                                                        freelance writing career
                                                        by upgrading to{" "}
                                                        <span>
                                                            ProWriter Plus.
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="col-lg-4 col-md-12 col-sm-6 col-12">
                                                    <a
                                                        href="/account/settings/membership"
                                                        target="_blank"
                                                        className="btn btn-primary d-block"
                                                    >
                                                        Upgrade to Plus
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <div className="card text-left">
                                        <div className="card-header">
                                            <div className="col-auto p-0">
                                                <h4 className="card-header-title">
                                                    Latest Job Listings
                                                </h4>
                                            </div>
                                            <div className="col-auto p-0 text-right">
                                                <a
                                                    target="_blank"
                                                    className="small"
                                                    href="/jobs/"
                                                >
                                                    View all
                                                </a>
                                            </div>
                                        </div>
                                        <div className="table-responsive mb-0">
                                            <table className="table table-sm table-nowrap card-table dashjobListing latest-job-listing">
                                                <thead>
                                                    <tr>
                                                        <th>Title</th>
                                                        <th>Industry</th>
                                                        <th>&nbsp;</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.jobs.map(
                                                        (item, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <a
                                                                            target="_blank"
                                                                            href={`/${item.link}`}
                                                                        >
                                                                            {
                                                                                item.title
                                                                            }
                                                                        </a>
                                                                    </td>
                                                                    <td>
                                                                        <p>
                                                                            {
                                                                                item
                                                                                    .industry
                                                                                    .name
                                                                            }
                                                                        </p>
                                                                    </td>
                                                                    <td className="text-right">
                                                                        <a
                                                                            target="_blank"
                                                                            href={`/${item.link}`}
                                                                            className="applyBtn"
                                                                        >
                                                                            Apply
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="d-md-none d-block">
                                        <Posts></Posts>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-xl-12 col-md-12">
                                    {this.state.collapseMenu === true ? (
                                        <CollapseMenu></CollapseMenu>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </Fragment>
        );
    }
}
Account.contextType = AppContext;
export default Account;



// WEBPACK FOOTER //
// ./src/components/writer/account/Account.js